import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@common/common.module';
import { MessageLogDialogComponent } from './message-log-dialog/message-log-dialog.component';
import { MessageLogComponent } from './message-log.component';

export const MESSAGE_LOG_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
    },
    {
        path: 'list',
        component: MessageLogComponent
    },
    {
        path: '**',
        redirectTo: 'list'
    }
];
@NgModule({
    imports: [CommonModule, RouterModule.forChild(MESSAGE_LOG_ROUTES)],
    declarations: [MessageLogComponent, MessageLogDialogComponent]
})
export class MessageLogsModule {}
